export function convertArrayToMap<T>(
  array: T[],
  idFieldName: keyof T
): Record<string, T> {
  const result = {} as Record<string, T>;
  for (const value of array) {
    const fieldId = value[idFieldName] as string;
    result[fieldId] = value;
  }
  return result;
}
